import { getCommonOptionStylesAsClassName } from '@components/option';
import { twMerge } from 'tailwind-merge';

export const getOptionListHeaderStylesAsClassName = (): string => {
  return twMerge(
    getCommonOptionStylesAsClassName,
    'text-gray-dark border-b border-gray-light border-solid'
  );
};
